/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import { Link, breakpoints } from '@coursera/cds-core';

import { TrackedA } from 'bundles/page/components/TrackedLink2';
import Card from 'bundles/shared-articles/components/ArticleCard';
import type { ArticleHubCardProps } from 'bundles/shared-articles/types';

const styles = {
  link: () => css`
    border-radius: var(--cds-spacing-100);
    display: block;
    min-height: 256px;
    transition: box-shadow ease-out 250ms;

    ${breakpoints.up('sm')} {
      min-height: 460px;
    }

    &:hover,
    &:focus,
    &:active {
      text-decoration: none;
    }

    &:hover,
    &:focus-visible {
      box-shadow: 0 2px 10px rgb(0 0 0 / 20%);
      outline: none;
    }
  `,
};

export const ArticleHubCard = ({
  slug,
  title,
  subtitle,
  metadata,
  image,
  imageLazyLoad,
  estimatedReadTimeLabel,
  cardLink,
  isFeatured,
}: ArticleHubCardProps) => {
  return (
    <Link
      css={styles.link}
      component={TrackedA}
      data={{ slug, title }}
      href={cardLink}
      trackingName="article_hub_card"
      variant="quiet"
      data-e2e="article-hub-card"
    >
      <Card
        title={title}
        subtitle={subtitle}
        metadata={{ ...metadata, estimatedReadingTime: estimatedReadTimeLabel }}
        image={image}
        imageLazyLoad={imageLazyLoad}
        isFeatured={isFeatured}
      />
    </Link>
  );
};

export default ArticleHubCard;
